import { CampaignPrice } from "../../../../Model/CampaignPrice.csharp";
import { ServicePricingSummary } from "../../../Partials/PricingHighlight/ServicePricingSummary.csharp";

export const getBaseEndPrice = (pricingSummary: ServicePricingSummary) => {
  const getBasePrice = () => {
    let price = pricingSummary.basePrice;

    if (pricingSummary.showWeekendEveningPrices) {
      if (pricingSummary.isWeekendOrHoliday)
        price = price + pricingSummary.weekendHolidayAddition;
      else if (pricingSummary.isEvening)
        price = price + pricingSummary.eveningAddition;
    }

    return price;
  };

  const baseFeesCost = pricingSummary.baseFees.reduce(
    (prev, current) => prev + current.regularPrice,
    0
  );

  return getBasePrice() + baseFeesCost;
};

export const calculateTotalPrice = (pricingSummary: ServicePricingSummary) => {
  const getEndPrice = () => {
    const baseEndPrice = getBaseEndPrice(pricingSummary);

    return (
      baseEndPrice -
      getDiscount(
        pricingSummary.isWeekendOrHoliday,
        pricingSummary.isEvening,
        pricingSummary.campaignPrice
      )
    );
  };

  return getEndPrice();
};

export const getDiscount = (
  isWeekendOrHoliday: boolean,
  isEvening: boolean,
  campaignPrice?: CampaignPrice
) => {
  if (isWeekendOrHoliday)
    return campaignPrice?.weekendHolidayTotalDiscount ?? 0;
  if (isEvening) return campaignPrice?.eveningTotalDiscount ?? 0;

  return campaignPrice?.regularTotalDiscount ?? 0;
};
